import CategoryBreadcrumbs from './CategoryBreadcrumbs'

export default CategoryBreadcrumbs
